import rollbar from 'rollbar';


class Logger {
    constructor() {
        const settings = {};

        this.Rollbar = rollbar.init({
            accessToken: '4dd117056806406ba530b44548ca79b5',
            captureUncaught: true,
            captureUnhandledRejections: true,
            enabled: true,
            payload: {
                environment: process.env.NODE_ENV,
                client: {
                    javascript: {
                        source_map_enabled: true,
                        code_version: process.env.COMMIT_HASH,
                        guess_uncaught_frames: true,
                    },
                },
                person: {
                    id: '',
                    spotId: '',
                    tabletId: '',
                },
            },
        });
        window.Rollbar = this.Rollbar;
    }

    log = (message, payload) => {
        console.log(message, payload);
        this.Rollbar.log(message, payload);
    };

    error = (message, payload) => {
        console.error(message, payload);
        this.Rollbar.error(message, payload);
    };
}


export default new Logger();



// WEBPACK FOOTER //
// ./resources/js/logger.js